import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-records',
  templateUrl: './employee-records.component.html'
  
})
export class EmployeeRecordsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/time/components/employee-records/employee-records.component.ts